<template>
  <!--自定义组件通常都写于modal中-->
  <a-modal visible @ok="handleOk" @cancel="handleCancel">
    <a-form layout="vertical">
      <ak-inputs v-model="data" :options="options" ref="input" />
      <div>
        <div style="color:rgba(0, 0, 0, 0.85)" class="m-b-8">税率</div>
        <a-select :default-value="data.taxRate" @change="handleChange">
          <a-select-option
            v-for="(item,index) in gdDynamicVariable"
            :key="index"
            :value="item"
          >{{item}}</a-select-option>
        </a-select>
      </div>
    </a-form>
  </a-modal>
</template>
<script>
import NP from 'number-precision'
// import Json from './../../assets/json/schema.json'

export default {
  data () {
    return {
      dynamicVariable: null,
      // rateShowed: this.record.taxRate,
      gdDynamicVariable: [], // 税率
      data: {
        amount: this.record.amount, // 吨数
        shipping: this.record.shipping, // 运费
        pricePerTon: this.record.pricePerTon, // 每吨运费
        sellingPrice: this.record.sellingPrice, // 售价
        profit: this.record.profit,
        taxRate: this.record.taxRate,
      },
      objectId: this.record.objectId,
      options: [
        {
          name: 'shipping',
          note: '运费',
          type: 'Number',
          validators: [
            (val) => val ? null : '运费不可为空',
            (val) => {
              if (val <= 0) {
                return '请输入正确的运费'
              }
            }
          ]
        },
        {
          name: 'amount',
          note: '吨数',
          type: 'Number',
          validators: [
            (val) => val ? null : '吨数不可为空',
            (val) => {
              if (val <= 0) {
                return '请输入正确的吨数'
              }
            }
          ]
        },
        {
          name: 'sellingPrice',
          note: '售价',
          type: 'Number'
        },
        {
          name: 'pricePerTon',
          note: '每吨运费',
          type: 'Number',
          disabled: true
        }
      ]
    }
  },
  mounted () {
    console.log('获取利润', this.record.profit)
  },
  methods: {
    // 计算利润
    async getProfit () {
      await this.$tkHelper.sleep(300)

      if (this.record.costPrice !== '' && this.data.amount !== '' && this.record.packid !== '' && this.record.palletid !== '' && this.data.sellingPrice !== '' && this.data.pricePerTon !== '' && this.record.clientCommission !== '') {
        if (this.record.shopManagementid.profitRatio1 === null || this.record.modelId.profitRatio2 === null || this.record.shopManagementid.amountRatio1 === null || this.record.modelId.amountRatio2 === null) {
          this.data.profit = null
        } else {
          let { data: res1 } = await this.$tkParse.get('/settings')
          let amountCommissionRadix = res1.amountCommission
          let amountCommission = NP.round(NP.times(amountCommissionRadix, this.record.shopManagementid.amountRatio1, this.record.modelId.amountRatio2), 2)
          let orderSalaryP = NP.round(NP.divide(NP.times(NP.minus(this.data.sellingPrice, NP.times(this.data.taxRate, this.data.sellingPrice), this.data.pricePerTon, this.record.clientCommission, this.record.packid.price, this.record.palletid.price, this.record.costPrice), NP.times(this.record.shopManagementid.profitRatio1, this.record.modelId.profitRatio2, this.data.amount)), NP.plus(1, NP.times(this.record.shopManagementid.profitRatio1, this.record.modelId.profitRatio2, this.data.amount))), 2)
          let orderSalaryT = NP.round(NP.times(amountCommission, this.data.amount), 2)
          // let profitP = NP.round(NP.minus(NP.minus(this.data.sellingPrice, NP.times(this.data.sellingPrice, this.data.taxRate), this.data.pricePerTon, this.record.clientCommission, this.record.packid.price, this.record.palletid.price, orderSalaryP), this.record.costPrice), 2)
          // let profitT = NP.round(NP.minus(NP.minus(this.data.sellingPrice, NP.times(this.data.sellingPrice, this.data.taxRate), this.data.pricePerTon, this.record.clientCommission, this.record.packid.price, this.record.palletid.price, orderSalaryT), this.record.costPrice), 2)
          this.data.profit = NP.round(NP.minus(NP.times(NP.minus(this.data.sellingPrice, NP.times(this.data.sellingPrice, this.data.taxRate), this.record.clientCommission, this.record.packid.price, this.record.palletid.price, this.record.costPrice), this.data.amount), this.data.shipping, Math.max(orderSalaryP, orderSalaryT)), 2)
          console.log('计算利润', this.data.profit)
        }
      }
    },
    // 自动修正每吨运费
    pricePerTonRevise () {
      this.data.pricePerTon = NP.round(NP.divide(this.data.shipping, this.data.amount), 2)
    },
    async handleOk () {
      try {
        if (this.dynamicVariable) {
          // 税率改变
          this.data.taxRate = this.dynamicVariable
        }
        await this.getProfit()
        await this.$modelAjax.put('Order', this.objectId, this.data)
        this.$notification.success({
          message: '保存成功',
          description: '数据已保存'
        })
        this.vm.refresh()
        this.$emit('complete', 'cancel')
      } catch (e) {
        console.log('出错', e)
        this.$notification.error({
          message: '网络错误',
          description: '网络错误'
        })
      }
    },
    // 获取分式变量
    async getDynamicVariable () {
      const { data: res } = await this.$tkParse.get('/settings')
      let dynamicVariableArray = ['dynamicVariable', 'dynamicVariable1', 'dynamicVariable3', 'dynamicVariable4', 'dynamicVariable5']
      for (let i in res) {
        if (dynamicVariableArray.indexOf(i) !== -1) {
          let num = NP.divide(res[i], 100)
          this.gdDynamicVariable.push(num)
        }
      }
    },
    // 税率发生变化时调用
    handleChange (value) {
      this.dynamicVariable = value
    },
    handleCancel () {
      // this.vm.refresh()
      this.$emit('complete')
    }
  },
  created () {
    this.getDynamicVariable()
    this.handleChange()
    this.unWatch0 = this.$watch(() => this.data.shipping, this.pricePerTonRevise)
    this.unWatch1 = this.$watch(() => this.data.amount, this.pricePerTonRevise)
  },

  // 你可以接收到以下props，这些与自定义callback的action参数完全一致
  props: {
    record: Object, // 当前行的数据
    vm: Object, // 触发这个action的组件对象，通常为modelTable或modelTree
    fields: Array, // 当前model的fields对象
    model: Object, // 当前model对象
    className: String, // 当前model的className
    modelName: String, // 当前model的名称
    category: String // 假如当前model显示为category格式，则会将当前的值传入
  },
}
</script>

<style>

</style>
